import { createGlobalStyle, css } from 'styled-components';
import { createTheme } from '@material-ui/core/styles';

export const GlobalStyles = createGlobalStyle`
*{
    box-sizing:border-box;
    margin: 0px;
    padding: 0px;
}
html, body, #root, .App{
    height: 100%;
}
`;

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0079C1',
    },
    secondary: {
      main: '#E04343',
    },
  },
  typography: {
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
  },
  overrides: {
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: '#0078C1',
          fontWeight: 'normal',
        },
      },
      focused: {},
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: '#0078C1',
        },
      },
    },
    MuiTableBody: {
      root: {
        borderTop: '1px solid red',
      },
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
    },
  },
});

export const customScrollBars = css`
  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #d8d8d8;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background: #0079c1;
    border: 2px solid #d8d8d8;
    border-radius: 20px;
  }
`;
